import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class PhaseService {
	private _selectedPhase$: Subject<any[]>;
	public phase$: BehaviorSubject<any>;
	public gridApi = null;
	constructor(private http: HttpClient) {
		this._selectedPhase$ = new Subject();
		this.phase$ = new BehaviorSubject('default');
	}

	get phases$(): Observable<any> {
		return this.http.get<any>(`${environment.apiUrl}/main/phases/`);
	}
	get phase() {
		return this.phase$.value;
	}
	public studentPhase$(participantId: number): Observable<any> {
		return this.http.get<any>(
			`${environment.apiUrl}/main/participantPhases/participantId/${participantId}`,
		);
	}

	public setPhase(phase: any) {
		this._selectedPhase$.next(phase);
		this.phase$.next(phase);
		this.clearGrids();
		localStorage.setItem('selectedPhase', JSON.stringify(phase));
	}

	get selectedPhase$() {
		return this._selectedPhase$.asObservable();
	}

	setGridApi(grids) {
		this.gridApi = grids;
	}

	clearGrids() {
		if (Array.isArray(this.gridApi)) {
			this.gridApi.forEach(function (grid) {
				grid.setPinnedBottomRowData([]);
				grid.showNoRowsOverlay();
			});
		}
	}
}
